<div class="px-8 py-6 flex flex-col bg-neutral min-w-[360px]">
  <!-- Header -->
  <h2 class="font-spaceGrotesk font-semibold text-[22px] text-inverted-neutral mb-1">Switch Account</h2>
  <p class="inter-300 text-base-200 text-[13px] mb-5">Select an account to switch to</p>

  <div class="w-full h-[1px] bg-textbox-border rounded-full mb-4"></div>

  <!-- Account list -->
  <div class="flex flex-col gap-2">
    @for (account of data.availableAccounts; track account) {
      <div (click)="swapAccount(account)"
           class="flex items-center justify-between px-4 py-3 rounded-[12px] cursor-pointer transition-colors duration-150 hover:bg-base-100 group">
        <p class="inter-500 text-[16px] text-inverted-neutral group-hover:text-kek-purple transition-colors">{{ account.displayName }}</p>
        @if (account.guid === activeAccountGuid) {
          <span class="material-icons-outlined text-[20px] text-kek-purple">check_circle</span>
        }
      </div>
    }
  </div>

  <div class="w-full h-[1px] bg-textbox-border rounded-full my-4"></div>

  <!-- Add new account -->
  <div (click)="createAccount()"
       class="flex items-center gap-3 px-4 py-3 rounded-[12px] cursor-pointer transition-colors duration-150 hover:bg-base-100 group">
    <span class="material-icons text-[20px] text-base-200 group-hover:text-kek-purple transition-colors">add_circle_outline</span>
    <p class="inter-500 text-[15px] text-base-200 group-hover:text-kek-purple transition-colors">Add New Account</p>
  </div>
</div>
